module.exports = "/_next/static/images/CollectionLibraries@2x-e7ac8d52c784645f2f1aabbd58cc3a26.webp";